const Carousel = require('./carousel');


class ThemeCarousel extends Carousel {}

module.exports = ThemeCarousel;
